export default __webpack_public_path__ + "static/0280-3a948a48d0dfc223da41d446d0eb1b54.png";